
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-opacity":".01","fill":"#FFF","d":"M0 0h20v20H0z"}}),_c('path',{attrs:{"d":"M16.244 5.541c0 .41-.336.742-.75.742H9.612a2.248 2.248 0 01-2.114 1.466 2.248 2.248 0 01-2.114-1.466H4.5a.746.746 0 01-.75-.742c0-.41.336-.742.75-.742h.884a2.248 2.248 0 012.114-1.466c.947 0 1.792.586 2.114 1.466h5.882c.414 0 .75.332.75.742zm-1.736 2.282a2.227 2.227 0 011.727 2.424 2.24 2.24 0 01-2.24 1.97 2.248 2.248 0 01-2.115-1.484H4.5a.746.746 0 01-.75-.742c0-.41.336-.741.75-.741h7.38a2.253 2.253 0 012.628-1.427zm1.736 6.619c0 .41-.336.741-.75.741h-4.55a2.248 2.248 0 01-4.228 0H4.5a.746.746 0 01-.75-.741c0-.41.336-.742.75-.742h2.216a2.248 2.248 0 012.114-1.466c.947 0 1.792.586 2.115 1.466h4.549c.414 0 .75.332.75.742zM8.248 5.54a.746.746 0 00-.75-.742.746.746 0 00-.75.742c0 .41.336.742.75.742s.75-.332.75-.742zm1.332 8.9a.746.746 0 00-.75-.741.746.746 0 00-.75.742c0 .41.336.741.75.741s.75-.332.75-.741zm5.164-4.45a.746.746 0 00-.75-.741.746.746 0 00-.75.741c0 .41.336.742.75.742.415 0 .75-.332.75-.742z"}})])
          )
        }
      }
    